/** @format */

import { isNumber } from 'lodash';
import { Link } from 'react-router-dom';
import React from 'react';
import { Tooltip } from 'src/components/tooltip';

export const ContactWidget = props => {
  const { image, link, nid, linkTitle, w, h, title, tooltip } = props.data;
  const fullImage = process.env.REACT_APP_API_URL + image;
  const linkRedirect = link;
  const internalLink = nid;
  const linkTitleContact = props.data && linkTitle.length > 1 ? linkTitle : '';

  return (
    <div className={`contactWidget ${internalLink ? `contact-link` : ``}`} data-width={w} data-height={h}>
      <img src={fullImage} alt="card-icon" />
      <div className="card-body">
        <h2 className="card-title">{title}</h2>
        {internalLink ? (
          <Link className="card-text" to={`/page/public/${internalLink}`}>
            {linkTitleContact}
          </Link>
        ) : (
          <a
            className="card-text"
            href={linkRedirect && linkRedirect.includes('@') ? `mailto:${linkRedirect}` : `tel:${linkRedirect}`}
          >
            {linkTitleContact}
          </a>
        )}
      </div>
      {tooltip && (
        <div className="contactWidget--list-item-tooltip">
          <Tooltip content={tooltip} placement="bottom" />
        </div>
      )}
    </div>
  );
};
